import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectAboutsFetched, {
	type SubjectAboutsFetchedAction,
	type SubjectAboutsFetchedPayload,
} from '@Application/SubjectTypeDefinitions/Actions/subjectAboutsFetched';
import subjectAboutsFetchFailed, {
	type SubjectAboutsFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectAboutsFetchFailed';
import type FetchSubjectAbouts from '@Application/SubjectTypeDefinitions/Queries/FetchSubjectAbouts';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectAboutsFetchedAction | SubjectAboutsFetchFailedAction;

export default (_query: FetchSubjectAbouts) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<SubjectAboutsFetchedPayload>(
				`${parameters.api.host}/api/enums/subject-abouts`,
			);

			const action = subjectAboutsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectAboutsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
